import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import ToolsHelper from '@core/services/tools.helper';

@Component({
  name: 'bpc-display-field-price-with-status',
  components: {},
})
export default class DisplayFieldPriceWithStatus extends mixins(AbstractDisplayField) {
  formatPrice(value: string) {
    if (!value) {
      return '';
    } else {
      return ToolsHelper.formatPrice(value);
    }
  }
}
